import React from "react";
import FeatureCard from "../SiteFeatures/FeatureCard";

import { Type, Anchor } from "discover.medical.react-component-library";
import { FreeToolBanner } from "./_.styled";

import {
  logResourceTileLinkClicked,
  logDecisionsPlacardClicked,
  AFFORDANCE,
} from "../../util/analytics";

import { useStore } from "../../store";
import { getSeamlessLink } from "../../util/seamlessAuth";

const PromotedTool = ({ className }) => {
  const { promotedDDTool } = useStore().home || {};
  const { an = "", title = "", description = "", slug = "" } =
    promotedDDTool || {};

  const handleClick = (evt) => {
    const affordance = AFFORDANCE.rightRail;
    logResourceTileLinkClicked("DynaMed Decisions");
    logDecisionsPlacardClicked({
      an,
      title,
      affordance,
    });
  };

  // no promotedDDTool, don't render anything
  if (!promotedDDTool || promotedDDTool.error) {
    return null;
  }

  return (
    <section className={className}>
      <FeatureCard
        heading="DynaMed Decisions"
        portraitSrc="https://resources.ebsco.zone/mfe-container/assets/images/call-to-action-dd-tool.jpg"
      >
        <Type fontSize="sm">
          DynaMed Decisions offers{" "}
          <strong>evidence-based clinical decision support</strong> and{" "}
          <strong>shared decision-making tools</strong>
        </Type>

        <div>
          <FreeToolBanner>
            <strong>Try a FREE tool:</strong>
          </FreeToolBanner>
        </div>

        <Anchor
          fontWeight="bold"
          onClick={handleClick}
          href={getSeamlessLink(slug)}
          data-gated="open"
        >
          {title}
        </Anchor>

        {description && (
          <Type element="p" fontSize="sm" marginBottom="sm">
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </Type>
        )}
      </FeatureCard>
    </section>
  );
};

export default PromotedTool;
